/**
 * @file zodiac.js
 * Contains data and logic for Chinese zodiac calculations and Thai month names.
 */

export const thaiMonths = {
  1: "ม.ค.",
  2: "ก.พ.",
  3: "มี.ค.",
  4: "เม.ย.",
  5: "พ.ค.",
  6: "มิ.ย.",
  7: "ก.ค.",
  8: "ส.ค.",
  9: "ก.ย.",
  10: "ต.ค.",
  11: "พ.ย.",
  12: "ธ.ค.",
};

const ZODIAC_ANIMALS = [
  { thai: "ปีชวด (หนู)", english: "Rat" },
  { thai: "ปีฉลู (วัว)", english: "Ox" },
  { thai: "ปีขาล (เสือ)", english: "Tiger" },
  { thai: "ปีเถาะ (กระต่าย)", english: "Rabbit" },
  { thai: "ปีมะโรง (มังกร / งูใหญ่)", english: "Dragon" },
  { thai: "ปีมะเส็ง (งูเล็ก)", english: "Snake" },
  { thai: "ปีมะเมีย (ม้า)", english: "Horse" },
  { thai: "ปีมะแม (แพะ)", english: "Goat" },
  { thai: "ปีวอก (ลิง)", english: "Monkey" },
  { thai: "ปีระกา (ไก่)", english: "Rooster" },
  { thai: "ปีจอ (สุนัข / หมา)", english: "Dog" },
  { thai: "ปีกุน (หมู)", english: "Pig" },
];

/**
 * Calculates the Chinese zodiac sign for a given Gregorian year.
 * @param {number} year - The Gregorian year.
 * @returns {string} The Thai and English name of the zodiac animal.
 */
export function getChineseZodiac(year) {
  const offset = 4; // Align cycle so that 1996 is Rat
  const index = (year - offset) % 12;
  const animal = ZODIAC_ANIMALS[(index + 12) % 12];
  return `${animal.thai} / ${animal.english}`;
}
